import { get } from "../../utils/objectHelpers";
import { enumTypes } from "./enumTypes";
$ {
    const rawMessage = get(input, "rawMessage", null);
    const errorObject = get(input, "message.title", {});
    const messageType = get(input, "message.messageType", "");
    const { allyText, status } = enumTypes(messageType);
}

<ebay-page-notice
    a11y-text=allyText
    status=status
    type="page"
    class="str-status app-layout">

    ${rawMessage}
    <str-textual-display ...errorObject/>
</ebay-page-notice>
